import { useClientTranslations } from "../../lib/i18n/client";
import type { TrainingItem as TrainingItemType } from "../../services/educationService";
import styles from "./TrainingItem.module.css";

interface TrainingItemProps {
	item: TrainingItemType;
}

export function TrainingItem({ item }: TrainingItemProps) {
	const { t, direction } = useClientTranslations("education");

	return (
		<button type="button" className={styles.card} dir={direction}>
			{item.isCompleted ? (
				<svg
					className={styles.checkbox}
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<title>{item.title}</title>
					<g clipPath="url(#clip-check-on)">
						<path
							d="M18.1669 8.33357C18.5474 10.2013 18.2762 12.1431 17.3984 13.8351C16.5206 15.527 15.0893 16.8669 13.3431 17.6313C11.597 18.3957 9.64154 18.5384 7.80293 18.0355C5.96433 17.5327 4.35368 16.4147 3.23958 14.8681C2.12548 13.3214 1.57529 11.4396 1.68074 9.53639C1.78619 7.63318 2.54092 5.82364 3.81906 4.40954C5.0972 2.99545 6.8215 2.06226 8.7044 1.76561C10.5873 1.46897 12.515 1.82679 14.166 2.7794"
							stroke="#5E60BF"
							strokeWidth="1.66667"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M7.5 9.16634L10 11.6663L18.3333 3.33301"
							stroke="#5E60BF"
							strokeWidth="1.66667"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
					<defs>
						<clipPath id="clip-check-on">
							<rect width="20" height="20" fill="white" />
						</clipPath>
					</defs>
				</svg>
			) : (
				<svg
					className={styles.checkbox}
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<title>{item.title}</title>
					<circle cx="10" cy="10" r="9" stroke="#C1C1C1" strokeWidth="2" />
				</svg>
			)}
			<div className={styles.content}>
				<span className={styles.title}>{item.title}</span>
				<div className={styles.subtitle}>
					<img
						src={`/images/education/icon-${item.contentType}.svg`}
						alt=""
						className={styles.subtitleIcon}
					/>
					<span className={styles.subtitleText}>
						{t(`contentTypes.${item.contentType}`)} · {item.duration}
					</span>
				</div>
			</div>
			<svg
				className={styles.chevron}
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>Navigate</title>
				<path
					d="M6 4L10 8L6 12"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	);
}
